import React from 'react'
import { Layout, Image } from 'antd'
import './MobileHeader.css'

const { Header } = Layout

const MobileHeader = () => (
  <Header className='MobileHeader'>
    <Image
      src='/img/logo.png'
      preview={false}
    />
  </Header>
)
export default MobileHeader
